import { render } from "./SelectedOrder.vue?vue&type=template&id=4bc8695c&scoped=true"
import script from "./SelectedOrder.vue?vue&type=script&lang=js"
export * from "./SelectedOrder.vue?vue&type=script&lang=js"

import "./SelectedOrder.vue?vue&type=style&index=0&id=4bc8695c&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bc8695c"]])

export default __exports__